/*
 * Created By sswaminathan
 * Created on Thu Sep 16 2021
 * Created on TenantProductListing.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */

import { useCallback, useContext } from 'react'
import { Body, Button } from '@panwds/react-ui-legacy'
import { LABEL_IN_PROGRESS } from '../../constants/LabelConstants'
import { LABEL_TENANT_SWITCHER_IP_RESTRICTED, LABEL_NO_INSTANCE_FOUND } from '../../../common/constants/LabelConstants'
import { getVarValue, setIsGlobalModuleOpen, launchAppInstance } from '../../../common/utils/Sparky'
import { FF_DISABLED_PRODUCT_LINKS } from '../../../common/utils/FeatureFlags'
import AppImage from '../../../common/components/appName/AppImage'
import AppContext from '../../../common/context/AppContext'

/**
 *
 * Takes the prodcuts list as an input and display the user products dynamicaly
 * SVG's are saved in the assets folder
 * @constructor
 */

/**
 *
 * @param globalDispatch
 * @param tenantProducts
 * @param color
 * @param isTenantSwitcherLoading
 * @returns {JSX.Element}
 * @constructor
 */

const TenantProductListing = ({
  tenantProducts,
  color,
  isTenantSwitcherLoading,
  isIPRestrictedError
}) => {

  const productLinksDisabled = getVarValue(FF_DISABLED_PRODUCT_LINKS)
  const { getAppName, dontRenderApp } = useContext(AppContext)
  const errorMessage = isIPRestrictedError ? LABEL_TENANT_SWITCHER_IP_RESTRICTED : LABEL_NO_INSTANCE_FOUND

  /**
   * Control which apps needs to render.
   */

  tenantProducts = tenantProducts.filter(each => !dontRenderApp(each.app_id) && !each.extra?.hidden && !each.runtime_attributes?.hidden)

  /**
   * Based on app_id lauch url in new tab or within same app.
   * @type {(function({app_id: *, tsg_id?: *, url?: *}): void)|*}
   */

  const handleOnProductClick = useCallback(({ app_id, tsg_id, url }) => {
    if (launchAppInstance({ app_id, tsg_id, url })) {
      setIsGlobalModuleOpen(false)
    }
  }, [])

  const className = `tw-flex tw-flex-row tw-justify-start tw-border-l-4
  focus:tw-outline-none focus:tw-ring-offset-0 hover:tw-bg-blue-steel-700 dark:cm-bg-black hover:tw-border-blue-400 hover:tw-border-l-4
  dark:hover:tw-bg-gray-800 dark:focus:tw-bg-gray-800 dark:active:tw-bg-gray-700
  focus:tw-border-l-4 focus:tw-border-blue-400 ${color}`

  if (isTenantSwitcherLoading) {
    return <div className='tw-flex tw-justify-center tw-items-center'>
      <Body level={2} size='sm' className='tw-text-white tw-text-left tw-border-0 color-primary'>Loading...</Body>
    </div>
  }
  return (
    <div className='tenant-product-listing'>
      {Array.isArray(tenantProducts) && tenantProducts?.length > 0 ? tenantProducts?.map((each, index) => {
        const isRunning = each.status === 'running'
        const displayAppId = each.app_launch_display_override || each.app_id_display_override || each.app_id
        return (
          <Button
            data-tsg-id={each.tsg_id}
            data-tenant-id={each.tenant_id}
            data-app-id={each.app_id}
            disabled={(!isRunning && productLinksDisabled)}
            style={{ opacity: (isRunning || !productLinksDisabled) ? 1 : 0.6 }}
            key={index}
            appearance='tertiary-clear'
            fullWidth
            onClick={handleOnProductClick.bind(this, each)}
            icon={<AppImage app_id={displayAppId} alt=' ' style={{ height: 'inherit', objectFit: 'contain', width: 'inherit' }} />}
            addClassName={className}
            size={'lg'}>
            <Body
              size='md'
              appearance='primary'
              addClassName='tw-pl-2 tw-text-white tw-color-primary tw-border-0'
            >
              {getAppName(displayAppId)}
            </Body>
            {(!isRunning && productLinksDisabled) && (
              <Body
                size='md'
                appearance='primary'
                addClassName='tw-pl-2 tw-text-white tw-color-primary tw-border-0'
              >({LABEL_IN_PROGRESS})</Body>
            )}
          </Button>
        )
      }) : <div className='tw-flex tw-justify-center tw-items-center'>
        <Body level={2} size='sm' className='tw-text-white tw-text-left tw-border-0 color-primary'>{errorMessage}</Body>
      </div>}
    </div>
  )
}
export default TenantProductListing
